import { createSelector } from '@ngrx/store';
import { IWorkspace } from './workspaces-model';

export const selectItems = (state) => state?.workspaces?.workspaces ?? [];

export const selectLoading = (state) => {
  return {
    loading: state?.workspaces?.loading,

    firstLoad: state?.workspaces?.isFirstLoad,
  };
};

export const selectInviteItems = (state) => state?.workspaces?.workspacesInvites ?? [];
export const selectWorkspacesInvitesSuccess = (state) => state?.workspaces?.updateWorkspacesInvitesSuccess ?? null;

export const getWorkspaceLoading = () =>
  createSelector(selectLoading, (isLoading) => {
    return isLoading.loading;
  });

export const getWorkspaces = () =>
  createSelector(selectItems, (workspaces: IWorkspace[]) => {
    return workspaces;
  });

export const getWorkspaceItem = (id) =>
  createSelector(selectItems, (workspaces: IWorkspace[]) => workspaces.find((workspace) => workspace.id === id));

export const getWorkspacesInvites = () =>
  createSelector(selectInviteItems, (invites: any) => {
    return invites;
  });

export const getWorkspaceFirstLoad = () =>
  createSelector(selectLoading, (isLoading) => {
    return isLoading.firstLoad;
  });

export const selectWorkspaceInvitesSuccess = () =>
  createSelector(selectWorkspacesInvitesSuccess, (data: any) => {
    return data;
  });

export const selectWorkspaceVaultConfig = (state) => state?.vaults;

export const getWorkspaceVaultConfig = () =>
  createSelector(selectWorkspaceVaultConfig, (workspaceVaults) => {
    return workspaceVaults?.vaults ?? [];
  });

// export const getWorkspaceVaultDataRegisters = () =>
//   createSelector(selectWorkspaceVaultConfig, (workspaceVaults) => {
//     return workspaceVaults?.dataRegisters ?? [];
//   });

export const getFormattedMembersByWorkspaceId = (workspaceId: string, creatorId?: string) =>
  createSelector(selectItems, (workspaces: IWorkspace[]) => {
    const memberData = workspaces.find((workspace) => workspace.id === workspaceId);
    if (!memberData) {
      return [];
    }

    return  memberData.members.reduce((acc, member) => {
      const mappedMember = {
        ...member,
        id: member?.userDetails?.id || member?.user_id,
        name: member?.userDetails?.name || '',
        relationship_name: '',
        user_profile_image_url: member?.userDetails?.profile_image_url || '',
      };
      if (!creatorId || mappedMember.id !== creatorId) {
        acc.push(mappedMember);
      }
      return acc;
    }, [] as any[]);
  });
